import type { Translations } from '@/lib/i18n';
import type { SubscriptionStatus } from '@/types';

// Cents -> "$34" / "$34.95" — same rounding rule as the onboarding tier
// picker's formatMonthlyPrice (src/routes/onboarding/step-tier.tsx), reused
// here for both monthly and annual prices.
export function formatPrice(cents: number): string {
  const dollars = cents / 100;
  return `$${dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2)}`;
}

// Same hand-rolled status-pill color convention as job/quote status
// (src/routes/jobs/helpers.ts statusColorClass).
export function subscriptionStatusColorClass(status: SubscriptionStatus): string {
  switch (status) {
    case 'active':
      return 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400';
    case 'past_due':
      return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400';
    case 'canceled':
      return 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400';
    default:
      return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
  }
}

export function subscriptionStatusLabel(
  status: SubscriptionStatus,
  t: Translations,
): string {
  switch (status) {
    case 'active':
      return t.billingStatusActive;
    case 'past_due':
      return t.billingStatusPastDue;
    case 'canceled':
      return t.billingStatusCanceled;
    default:
      return t.billingStatusTrialing;
  }
}
